<template>
  <div>
    <Onboarding
      :visible="showOnboarding || showDicomWarning"
      :dicom-warning="showDicomWarning"
      :step="1"
      placement="left"
    >
      <template v-slot:content>
        <div v-if="!showDicomWarning">
          <div class="step-content" v-html="$t('step1')"></div>
        </div>
        <div v-else class="check-dicoms-info" @click="closeDicomWarning">
          <div>
            {{ $t("Files select") }}: <b>{{ total_files }}</b>
          </div>
          <div class="m-t">
            {{ $t("Access files") }}: <b>{{ total_files_filter }}</b
            >. {{ $t("Access files about") }}
          </div>
          <div class="m-t">
            {{ $t("Skip files") }}: <b>{{ total_files - total_files_filter }}</b
            >. {{ $t("Tags values") }}
            <b>{{ dicomErrorsTags.toString().replaceAll(",", ", ") }}</b>
            {{ $t("Skip files about") }}
          </div>
          <i class="fa-light fa-xmark"></i>
        </div>
      </template>
      <template v-slot:trigger>
        <div
          class="upload-proccess-con"
          v-if="is_upload || notifying.enabled"
          @click="notifying.enabled ? (notifying.enabled = false) : false"
          v-bind:class="{
            'notifying-type__error':
              notifying.type === 'error' && notifying.enabled,
            'notifying-type__success':
              notifying.type === 'success' && notifying.enabled,
            'notifying-mode': notifying.enabled,
            'proccess-done': isSomeProcessDone && !upload.panel,
            'animated slideInRight': upload.panel,
            'animated slideOutRight': !upload.panel,
          }"
        >
          <div class="upload-proccess-inner">
            <div class="upload-proccess__on" v-if="upload.panel">
              <i
                v-if="!notifying.enabled"
                class="fa fa-angles-right animated"
                v-bind:class="{
                  fadeIn: !upload.panel,
                }"
                @click="showOnboarding ? false : (upload.panel = false)"
              ></i>
              <span class="main-inline upload-proccess-text dash-text__500">
                {{ notifying.enabled ? notifying.text : upload.text }}
              </span>
              <a-progress
                v-if="!notifying.enabled"
                :percent="upload.percent"
                status="active"
                :stroke-color="isSomeProcessDone ? '#54B466' : '#CE0F6F'"
                class="main-inline upload-proccess-bar"
              >
                <template #format="percent">
                  <span>{{ parseInt(percent) }}%</span>
                </template>
              </a-progress>
            </div>
            <div
              class="upload-proccess__off"
              v-if="!upload.panel"
              @click="upload.panel = true"
            >
              <i
                class="fa fa-angles-left animated"
                v-bind:class="{
                  fadeIn: upload.panel,
                }"
                @click="upload.panel = true"
              ></i>
              <span
                class="dash-text__16 dash-text__500"
                v-if="!isSomeProcessDone"
              >
                {{ parseInt(upload.percent) }}%
              </span>
              <i class="fa fa-regular fa-circle-check" v-else> </i>
            </div>
          </div>
        </div>
      </template>
    </Onboarding>

    <input
      ddd="111"
      v-for="(way, way_index) in uploadWays"
      :key="way.id"
      :ref="way.id"
      class="none"
      type="file"
      v-bind="attributes[way_index]"
      @change="startUpload"
      @click="onAbort"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import JSZip from "jszip";

// import { saveAs } from "file-saver";

import * as tus from "tus-js-client";

import Onboarding from "Components/Onboarding";

import dicomParser from "dicom-parser";

export default {
  components: {
    Onboarding,
  },
  data() {
    return {
      rules: [
        {
          required: true,
          tag: "x0020000d",
          tagName: "StudyInstanceUID",
          type: "exist",
          rules: {
            mg: true,
            dx: true,
            head_ct: true,
            chest_ct: true,
          },
        },
        {
          required: true,
          tag: "x0020000e",
          tagName: "SeriesInstanceUID",
          type: "exist",
          rules: {
            mg: true,
            dx: true,
            head_ct: true,
            chest_ct: true,
          },
        },
        {
          required: true,
          tag: "x00080060",
          tagName: "Modality",
          type: "equality",
          rules: {
            mg: ["MG", "MRI", "CR"],
            dx: ["RF", "DX", "CR", "OT"],
            head_ct: ["CT"],
            chest_ct: ["CT"],
          },
        },
        {
          required: false,
          tag: "x00180050",
          tagName: "SliceThickness",
          type: "comparison",
          rules: {
            head_ct: [-Infinity, 3],
            chest_ct: [-Infinity, 5],
          },
        },
        {
          tag: "x00180015",
          tagName: "BodyPartExamined",
          type: "indexOf",
          rules: {
            head_ct: ["HEAD", "BRAIN"],
            chest_ct: ["CHEST", "LUNG", "THORAX", "ABDOMEN"],
            mg: ["BREAST"],
          },
        },
        {
          tag: "x00101010",
          tagName: "PatientsAge",
          type: "age",
          age_type: "y",
          rules: {
            mg: [18, Infinity],
            dx: [18, Infinity],
            head_ct: [18, Infinity],
            chest_ct: [18, Infinity],
          },
        },
      ],
      dataSets: [],
      showDicomWarning: false,
      parsedDicoms: 0,
      dicomErrorsTags: [],
      tempCloseAnotherModal: true,
      dicomParserError: undefined,

      showOnboarding: false,
      notifying: {
        enabled: false,
        text: undefined,
      },
      sumZipFilesCount: undefined,
      sumZipSize: undefined,
      sumFilesSize: undefined,
      currentWay: undefined,
      dicomErrorsModalityes: [],
      total_files: 0,
      total_files_filter: 0,
      dicomParser: dicomParser,
      filesStack: [],
      bulk_id: undefined,
      tour: false,
      worker: undefined,
      selected_files_limit_size: 5,
      endpoint: "158.160.38.58",
      //   max_zip_size: 524288000,
      max_zip_size: 104857600,
      selectedServiceForCurrentUpload: undefined,
      upload: {
        panel: true,
        text: null,
        percent: 0,
        part_percent: 0,
      },
      zip_count: 0,
      zip_done: 0,
      isSomeProcessDone: false,
    };
  },
  beforeDestroy() {
    this.$root.$off("selectFiles", this.selectFiles);
    this.$root.$off("closeAllOnboardings", this.closeAllOnboardingsHandler);
    this.$root.$off("hideOnboarding", this.hideOnboarding);
  },
  created() {
    this.upload.text = this.$t("Wait");
    this.$accessModule("upload", this);
    this.$root.$on("selectFiles", this.selectFiles);
    this.$root.$on("closeAllOnboardings", this.closeAllOnboardingsHandler);
    this.$root.$on("hideOnboarding", this.hideOnboarding);
  },
  computed: {
    ...mapGetters([
      "uploadWays",
      "is_upload",
      "api",
      "token",
      "currentService",
      "bodyclick",
      "user",
      "services",
      "module",
      "moduleObject",
      "modules",
      "currentServiceObject",
      "currentLesson",
    ]),
    uploadApiHost() {
      return this.$_.findWhere(this.$root.env, { id: "upload" }).baseURL;
    },
    attributes() {
      return this.uploadWays.map((way) => {
        return way.attributes
          ? way.attributes.map((attr) => {
              return {
                [attr.key]: attr.value ? attr.value : "",
              };
            })
          : null;
      });
    },
    freeFiles() {
      return this.filesStack.filter((file) => {
        return !file.upload_status;
      });
    },
    zip_status() {
      return (
        this.$t("Zip processed") + ": " + this.zip_count + " / " + this.zip_done
      );
    },
    zips_ready() {
      return this.zip_count > 0
        ? this.zip_done === this.zip_count
          ? true
          : false
        : false;
    },
    zip_procent() {
      return (this.zip_done * 100) / this.zip_count;
    },
    files_percent() {
      return (
        ((this.filesStack.length - this.freeFiles.length - 1) * 100) /
        this.filesStack.length
      );
    },
  },
  watch: {
    $route(to) {
      if (to.path.indexOf("view") !== -1) {
        this.upload.panel = false;
      } else {
        this.upload.panel = true;
      }
    },
    zip_done(val) {
      if (val > 0) {
        this.upload.percent = (val * 100) / this.zip_count;
      }
    },
    zips_ready(val) {
      if (val) {
        this.$debug("Все архивы готовы к аплоуду", "warning");
        // this.upload.text = this.$t("Done");
        // this.isSomeProcessDone = true;
        this.isSomeProcessDone = true;
        this.upload.percent = 100;

        setTimeout(() => {
          this.isSomeProcessDone = false;
          this.getBulk();
        }, 2000);
      }
    },
    is_upload(val) {
      if (val) {
        window.addEventListener("beforeunload", this.checkExit);
      } else {
        window.removeEventListener("beforeunload", this.checkExit);
      }
    },
  },
  methods: {
    hideOnboarding(step) {
      if (step === 1) {
        this.showOnboarding = false;
      }
    },
    closeDicomWarning() {
      this.tempCloseAnotherModal = false;
      this.showOnboarding = false;
      this.showDicomWarning = false;

      this.$nextTick(() => {
        this.tempCloseAnotherModal = true;
      });
    },
    closeAllOnboardingsHandler() {
      this.showOnboarding = false;
    },
    closeBulk(bulk_id) {
      this.api
        .closeBulk({
          url: bulk_id + "/finished_at/",
        })
        .then((response) => {
          if (response.data.dicom_index_url) {
            this.isSomeProcessDone = false;
            this.createOrder(bulk_id, this.selectedServiceForCurrentUpload);
            this.$debug(
              "Балк " + bulk_id + " закрыт",
              "warning",
              response.data
            );
          } else {
            throw response.data;
          }
        })
        .catch((error) => {
          this.$debug(
            "Ошибка закрытия балка " + bulk_id,
            "error",
            {
              error_response: JSON.stringify(error),
              data: {
                bulk_id: bulk_id,
                username: this.user.username,
                local_date: new Date(),
                files_count: this.filesStack.length,
                is_zipped: this.zip_count > 0,
                sum_files_size:
                  this.zip_count > 0 ? this.sumZipSize : this.sumFilesSize,
              },
            },
            true
          );

          this.isSomeProcessDone = false;

          this.clearUploadState(this.$t("Error upload"), "error");
        });
    },
    createOrder(bulk_id, selectedServiceForCurrentUpload) {
      const createOrder =
        this.api[
          "create" + this.$root.capitalizeFirstLetter(this.module) + "Order"
        ];

      createOrder({
        url:
          this.module !== "AI"
            ? ""
            : selectedServiceForCurrentUpload + "/orders/",
        data: {
          lesson_id: this.currentLesson,
          bulk_upload_id: bulk_id,
          description: {
            version: "0.3.0",
            atoms: [],
            cards: [],
            markups: [],
            sections: [[1, "p", []]],
          },
          is_public: true,
          is_anonymous: false,
          publish: false,
          title: null,
        },
      })
        .then((response) => {
          this.$debug(
            "Был создан заказ по закрытому балку id=" + bulk_id,
            "success",
            response
          );
          if (this.module === "community") {
            this.$router.push(
              "/community/cases/" + response.data.id + "/viewer?mode=edit"
            );
          }
          this.clearUploadState(this.$t("Success upload"), "success");
          this.$root.$emit("updateStudiesList");
          this.$root.getUserInfo();
        })
        .catch((error) => {
          this.$debug(
            "Ошибка создания заказа по закрытому балку id=" +
              bulk_id +
              " в сервис " +
              selectedServiceForCurrentUpload,
            "error",
            {
              error_response: JSON.stringify(error),
              data: {
                bulk_id: bulk_id,
                service: selectedServiceForCurrentUpload,
                username: this.user.username,
                local_date: new Date(),
                files_count: this.filesStack.length,
                is_zipped: this.zip_count > 0,
                sum_files_size:
                  this.zip_count > 0 ? this.sumZipSize : this.sumFilesSize,
              },
            },
            true
          );

          this.clearUploadState(this.$t("Error upload"), "error");
        });
    },
    onAbort() {
      document.body.onfocus = this.checkIt;
    },
    checkIt() {
      if (this.$refs[this.currentWay.id][0].files.length === 0) {
        document.body.onfocus = null;
        this.$root.$emit("setUploadButtonDisabledStatus", false);
      }
    },
    checkExit(e) {
      this.$debug(
        "ПОПЫТКА ПОКИНУТЬ БРАУЗЕР ВО ВРЕМЯ ЗАГРУЗКИ. КОНФИРМ!",
        "error",
        e
      );
      var confirmationMessage = "\o/";

      (e || window.event).returnValue = confirmationMessage; //Gecko + IE
      return confirmationMessage; //Webkit, Safari, Chrome
    },
    prepareFiles(files) {
      return files.map((file) => {
        return {
          id: this.rnd()(5),
          file: file,
          upload_status: undefined,
        };
      });
    },
    clearUploadState(message, message_type) {
      this.$store.dispatch("updateIsUpload", false);
      this.total_files = 0;
      this.selectedServiceForCurrentUpload = undefined;
      this.upload.text = this.$t("Wait");
      this.dicomParserError = undefined;
      this.dataSets = [];
      this.upload.percent = 0;
      this.sumZipFilesCount = undefined;
      this.tempCloseAnotherModal = true;
      this.sumZipSize = undefined;
      this.dicomErrorsModalityes = [];
      this.total_files_filter = 0;
      this.dicomErrorsTags = [];
      this.sumFilesSize = undefined;
      this.showDicomWarning = false;
      this.parsedDicoms = 0;
      this.bulk_id = undefined;
      this.zip_count = 0;
      this.zip_done = 0;
      this.filesStack = [];
      this.uploadWays.map((way) => {
        if (this.$refs[way.id]) {
          this.$refs[way.id][0].value = "";
        }
      });

      if (message) {
        this.notify({
          type: message_type,
          duration: message_type === "error" ? 50000 : 5000,
          text: message,
        });
      }
    },
    notify(message) {
      this.notifying = {
        enabled: true,
        text: message.text,
        type: message.type,
      };
      setTimeout(() => {
        this.notifying.enabled = false;
      }, message.duration);
    },
    runWorker(first) {
      const freeFile = this.freeFiles[0];

      this.upload.text = this.$t("Wait for loading");

      if (first) {
        this.upload.percent = 0;
      }

      if (!freeFile) {
        this.upload.percent = 100;

        this.showOnboarding = false;

        this.$debug(
          "Файлы кончились. Загрузка полностью завершена " + new Date(),
          "warning"
        );

        // this.upload.text = this.$t("Done");
        this.isSomeProcessDone = true;
        this.upload.percent = 100;

        setTimeout(() => {
          this.isSomeProcessDone = false;
          this.closeBulk(this.bulk_id);
        }, 2000);

        return;
      }

      freeFile.upload_status = "process";

      this.$debug("Начинаетя загрузка файла c типом", "warning");
      //this.$set(this.freeFiles[0], 'upload_status', "process");

      const mime =
        freeFile.file.type === "application/zip"
          ? "application/zipped-dicoms"
          : freeFile.file.type.indexOf("image") !== -1
          ? "application/image"
          : "application/dicom";

      this.worker = new tus.Upload(freeFile.file, {
        endpoint: this.uploadApiHost + "/bulk-uploads/" + this.bulk_id + "/",
        retryDelays: [0, 3000, 5000, 10000, 20000],
        headers: {
          Authorization: "Token " + this.token,
          "Upload-Metadata": `file-mime ${window.btoa(mime)}`,
        },
        chunkSize: 100 * 1024 * 1024,
        //todo chunk size 5 mib
        metadata: {
          filename: freeFile.file.name
            ? freeFile.file.name
            : this.rnd()(100) + ".zip",
          filetype:
            freeFile.file.type && freeFile.file.type !== ""
              ? freeFile.file.type
              : "application/dicom",
        },
        onError: (error) => {
          // if (error.message.indexOf(404) !== -1) {
          // }

          this.$debug(
            "Загрука с tus зафейлилась: " + error,
            "error",
            {
              error_response: JSON.stringify(error),
              data: {
                service: this.selectedServiceForCurrentUpload,
                bulk_id: this.bulk_id,
                username: this.user.username,
                local_date: new Date(),
                files_count: this.filesStack.length,
                is_zipped: this.zip_count > 0,
                sum_files_size:
                  this.zip_count > 0 ? this.sumZipSize : this.sumFilesSize,
              },
            },
            true
          );
          this.clearUploadState(this.$t("Upload error"), "error");
        },
        onProgress: (bytesUploaded, bytesTotal) => {
          var percentage = (bytesUploaded / bytesTotal) * 100;

          this.upload.percent =
            percentage / this.filesStack.length - 1 + this.files_percent;

          this.$debug(
            "Процесс загрузки " +
              bytesUploaded +
              "/" +
              bytesTotal +
              ": " +
              percentage +
              "%"
          );
        },
        onSuccess: () => {
          //   this.upload.percent =
          //     100 -
          //     parseInt((this.freeFiles.length * 100) / this.filesStack.length);

          this.$debug(
            "Загрузка файла завершена. линк на файл",
            "success",
            this.worker.url
          );
          this.runWorker();
        },
      });

      // this.worker.start();

      this.worker.findPreviousUploads().then((previousUploads) => {
        // Found previous uploads so we select the first one.
        if (previousUploads.length) {
          this.worker.resumeFromPreviousUpload(previousUploads[0]);
        }

        // Start the upload
        this.worker.start();
      });
    },
    selectFiles(way) {
      this.currentWay = way;
      this.$refs[way.id][0].click();
    },
    bytesToSize(bytes) {
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return "n/a";
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)), 10);
      if (i === 0) return `${bytes} ${sizes[i]})`;
      return `${(bytes / 1000 ** i).toFixed(1)} ${sizes[i]}`;
    },
    convertToGB(bytesValue) {
      return bytesValue / (1000 * 1000 * 1000);
    },
    createZip(files) {
      let zipes = [];

      let currentZip = undefined;
      let currentZipSize = 0;
      let currentZipFilesCount = 0;
      let sumZipSize = 0;
      let sumZipFilesCount = 0;

      this.upload.text = this.$t("Wait");
      this.upload.percent = 82;

      files.map((file, index) => {
        if (currentZipSize >= this.max_zip_size) {
          currentZip.currentZipFilesCount = currentZipFilesCount;
          currentZip.currentZipSize = currentZipSize;
          zipes.push(currentZip);
          currentZip = undefined;
          currentZipSize = 0;
          currentZipFilesCount = 0;
        }

        if (!currentZip) {
          currentZip = new JSZip();
        }

        currentZip.file(this.rnd()(20) + index, file.file, {
          binary: true,
        });
        currentZipSize += file.file.size;
        currentZipFilesCount += 1;
        sumZipSize += file.file.size;
        sumZipFilesCount += 1;
      });

      if (currentZip) {
        currentZip.currentZipFilesCount = currentZipFilesCount;
        currentZip.currentZipSize = currentZipSize;
        zipes.push(currentZip);
      }

      this.upload.text = this.$t("Upload process");
      this.upload.percent = 0;

      this.zip_count = zipes.length;

      if (this.zip_count === 0) {
        this.resetUpload();
        return;
      }

      this.$debug(
        "Сформировано " + this.zip_count + " архивов. Идет сжатие",
        "warning"
      );

      this.$debug(
        "Сводка по архивам: Всего файлов: " +
          sumZipFilesCount +
          " Суммарный вес: " +
          this.bytesToSize(sumZipSize)
      );

      this.sumZipFilesCount = sumZipFilesCount;
      this.sumZipSize = parseInt(sumZipSize / (1000 * 1000)) + "mb";

      zipes.map((zipe, index) => {
        this.$debug(
          index +
            " архив. Файлов: " +
            zipe.currentZipFilesCount +
            "; Вес: " +
            this.bytesToSize(zipe.currentZipSize)
        );
      });

      //   zipes.map((zip, index) => {
      //     zip.generateAsync({ type: "blob" }).then((content) => {
      //       this.$debug(index + "архив готов", "warning");
      //       this.filesStack.push({
      //         file: content,
      //         upload_status: undefined,
      //       });
      //       this.zip_done += 1;
      //     });
      //   });

      this.blobZipes(zipes);
    },
    blobZipes(zipes) {
      this._recurseBlobZipe(zipes, 0);
    },
    getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    },
    zipProcessed(metadata) {
      const percent = metadata.percent / this.zip_count + this.zip_procent;
      this.upload.percent =
        percent > 0 ? percent : this.getRandomArbitrary(1, 2);
    },
    rnd() {
      const gen = (min, max) =>
        max++ &&
        [...Array(max - min)].map((s, i) => String.fromCharCode(min + i));

      const sets = {
        num: gen(48, 57),
        alphaLower: gen(97, 122),
        alphaUpper: gen(65, 90),
      };

      function* iter(len, set) {
        if (set.length < 1) set = Object.values(sets).flat();
        for (let i = 0; i < len; i++)
          yield set[(Math.random() * set.length) | 0];
      }

      return Object.assign(
        (len, ...set) => [...iter(len, set.flat())].join(""),
        sets
      );
    },
    getBulk() {
      this.api
        .getBulk()
        .then((response) => {
          if (response.data && response.data.id) {
            this.bulk_id = response.data.id;
            this.runWorker(true);
          } else {
            throw response.data;
          }
        })
        .catch((error) => {
          this.$debug(
            "ошибка получения bulk id",
            "error",
            {
              error_response: JSON.stringify(error),
              data: {
                service: this.selectedServiceForCurrentUpload,
                username: this.user.username,
                local_date: new Date(),
                files_count: this.filesStack.length,
                is_zipped: this.zip_count > 0,
                sum_files_size:
                  this.zip_count > 0 ? this.sumZipSize : this.sumFilesSize,
              },
            },
            true
          );

          this.clearUploadState(this.$t("Upload error"), "error", error);
        });
    },
    _recurseBlobZipe(zipes, index) {
      zipes[index]
        .generateAsync(
          {
            type: "blob",
            compression: "STORE", // Без шифрования
            streamFiles: false,
          },
          this.zipProcessed
        )
        .then((content) => {
          // saveAs(content, index + "_dcm.zip");

          this.$debug(index + " архив готов", "warning");
          this.filesStack.push({
            file: content,
            upload_status: undefined,
          });
          this.zip_done += 1;

          if (zipes[index + 1]) {
            this._recurseBlobZipe(zipes, index + 1);
          }
        });
    },
    reachLimit(files) {
      let sum_size = 0;
      files.map((file) => {
        sum_size += file.file.size;
      });

      this.sumFilesSize = parseInt(sum_size / (1000 * 1000)) + "mb";

      const gb = this.convertToGB(sum_size);

      return gb > this.selected_files_limit_size
        ? gb.toFixed(2) + "Gb / " + this.selected_files_limit_size + "Gb"
        : false;
    },
    resetUpload() {
      this.$debug("Отмена аплоуда", "error");
      this.$store.dispatch("updateIsUpload", false);
    },
    anonimization(files) {
      this.reachLimit(files);

      this.isSomeProcessDone = false;
      this.upload.text = this.$t("Wait for anonimization");
      this.upload.percent = 0;

      if (
        !localStorage["step1_approve_" + this.user.username] &&
        this.user &&
        this.user.username !== "demo" &&
        !this.user.onboardingCompleted &&
        !(this.module === "edu")
      ) {
        setTimeout(() => {
          this.showOnboarding = true;
        }, 1000);
      }

      setTimeout(() => {
        this.upload.percent = Math.random() * (55 - 30) + 30;
        setTimeout(() => {
          this.upload.percent = Math.random() * (55 - 30) + 30;
          setTimeout(() => {
            this.isSomeProcessDone = true;
            this.upload.percent = 100;
            setTimeout(() => {
              this.isSomeProcessDone = false;
              if (files.length > 100) {
                this.createZip(files);
              } else {
                this.filesStack = files;
                this.getBulk();
              }
            }, 2000);
          });
        }, 700);
      }, 700);
    },
    checkDatasetForRules(d) {
      let dicom_ok = true;

      if (
        this.currentWay.id === "zip" &&
        (d.extension === "image/png" ||
          d.extension === "image/jpg" ||
          d.extension === "image/jpeg")
      ) {
        return true;
      }

      this.$debug(
        "Началась проверка файла: " +
          (d.filename || "<файл без имени>") +
          " загружаемого в сервис " +
          this.currentService,
        "warning"
      );

      if (!d.dataset) {
        this.$debug(
          "Ошибка! файл " + d.filename + " не является дайкомом",
          "error"
        );
        return false;
      }

      this.rules.map((rule) => {
        const tag_value = d.dataset.string(rule.tag);

        if (rule.rules[this.currentService]) {
          if (rule.required && !tag_value) {
            const error =
              "Тег " +
              rule.tag +
              " является обязательным но в dicom значение отсуствует";
            this.dicomParserError = error;
            this.$debug("DICOM PARSER: " + error, "error");
            dicom_ok = false;
            if (this.dicomErrorsTags.indexOf(rule.tagName) === -1) {
              this.dicomErrorsTags.push(rule.tagName);
            }
            return;
          } else {
            this.$debug(
              "DICOM PARSER: Тег " +
                rule.tag +
                " является обязательным и в dicom значение присутствует",
              "success",
              tag_value
            );
          }

          if (!rule.required && !tag_value) {
            const success =
              "Тег " +
              rule.tag +
              ". Его значение является не обязательным и отсуствует дальше можно не проверять";
            this.$debug("DICOM PARSER: " + success, "success");
            return;
          }

          switch (rule.type) {
            case "equality":
              if (rule.rules[this.currentService].indexOf(tag_value) === -1) {
                const error =
                  "Тег " +
                  rule.tag +
                  ". Его значение " +
                  tag_value +
                  " не равняется ни одному из элементов списка: " +
                  rule.rules[this.currentService];
                this.dicomParserError = error;
                this.$debug("DICOM PARSER: " + error, "error");
                dicom_ok = false;
                if (this.dicomErrorsTags.indexOf(rule.tagName) === -1) {
                  this.dicomErrorsTags.push(rule.tagName);
                }
                if (this.dicomErrorsModalityes.indexOf(tag_value) === -1) {
                  this.dicomErrorsModalityes.push(tag_value);
                }
              } else {
                const success =
                  "Тег " +
                  rule.tag +
                  ". Его значение " +
                  tag_value +
                  "  равняется одному из элементов списка: " +
                  rule.rules[this.currentService];
                this.$debug("DICOM PARSER: " + success, "success");
              }
              break;

            case "comparison":
              if (
                tag_value < rule.rules[this.currentService][0] ||
                tag_value > rule.rules[this.currentService][1]
              ) {
                const error =
                  "Тег " +
                  rule.tag +
                  ". Его значение " +
                  tag_value +
                  " должно быть в интервале: " +
                  rule.rules[this.currentService];
                this.dicomParserError = error;
                this.$debug("DICOM PARSER: " + error, "error");
                dicom_ok = false;
                if (this.dicomErrorsTags.indexOf(rule.tagName) === -1) {
                  this.dicomErrorsTags.push(rule.tagName);
                }
              } else {
                const success =
                  "Тег " +
                  rule.tag +
                  ". Его значение " +
                  tag_value +
                  " в интервале: " +
                  rule.rules[this.currentService];
                this.$debug("DICOM PARSER: " + success, "success");
              }
              break;

            case "indexOf":
              if (
                rule.rules[this.currentService].filter((r) => {
                  return tag_value.indexOf(r) !== -1;
                }).length === 0
              ) {
                const error =
                  "Тег " +
                  rule.tag +
                  ". В его значение " +
                  tag_value +
                  " не входит ни один из элементов списка: " +
                  rule.rules[this.currentService];
                this.dicomParserError = error;
                this.$debug("DICOM PARSER: " + error, "error");
                dicom_ok = false;
                if (this.dicomErrorsTags.indexOf(rule.tagName) === -1) {
                  this.dicomErrorsTags.push(rule.tagName);
                }
              } else {
                const success =
                  "Тег " +
                  rule.tag +
                  ". В его значение " +
                  tag_value +
                  " входит один из элементов списка: " +
                  rule.rules[this.currentService];
                this.$debug("DICOM PARSER: " + success, "success");
              }
              break;

            case "age":
              if (
                tag_value.toLowerCase().indexOf(rule.age_type) === -1 ||
                (tag_value.toLowerCase().indexOf(rule.age_type) !== -1 &&
                  (parseInt(tag_value) < rule.rules[this.currentService][0] ||
                    parseInt(tag_value) > rule.rules[this.currentService][1]))
              ) {
                const error =
                  "Тег " +
                  rule.tag +
                  ". Его значение " +
                  tag_value +
                  " должно быть в интервале: " +
                  rule.rules[this.currentService];
                this.dicomParserError = error;
                this.$debug("DICOM PARSER: " + error, "error");
                dicom_ok = false;
                if (this.dicomErrorsTags.indexOf(rule.tagName) === -1) {
                  this.dicomErrorsTags.push(rule.tagName);
                }
              } else {
                const success =
                  "Тег " +
                  rule.tag +
                  ". В его значение " +
                  tag_value +
                  " в интервале:  " +
                  rule.rules[this.currentService];
                this.$debug("DICOM PARSER: " + success, "success");
              }
              break;
          }
        }
      });

      console.log("\n\n");

      return dicom_ok;
    },
    getDataset(unit8array) {
      let result = undefined;
      try {
        result = dicomParser.parseDicom(unit8array);
      } catch {
        result = null;
      }
      return result;
    },
    filterDicoms(origFiles) {
      let filteredFiles = [];
      // ПЕРВЫЙ ШАГ - ВСЕ ДАЙКМОЫ
      // Смотрим Modality (0008,0060) / x00080060
      // Маммография: MG MRI
      // Рентгенография: RF DX CR
      // КТ головного мозга: CT
      // КТ органов грудной клетки: CT
      //---------------------
      // ВТОРОЙ ШАГ - IF head_ct/chest_ct
      // Смотрим SliceThickness (0018,0050) / x00180050
      // head_ct <= 3
      // chest_ct <= 5
      // ТРЕТИЙ ШАГ - IF mg/head_ct/chest_ct
      // Смотрим BodyPartExamined (0018,0015) / x00180015
      // length = 0
      // IF length > 0
      // head_ct = HEAD / BRAIN
      // chest_ct = CHEST / LUNG / THORAX
      // mg = BREAST
      // ЧЕТВЕРТЫЙ ШАГ - ВСЕ ДАЙКОМЫ
      // Смотрим PatientsAge (0010,1010) / x00101010
      // length = 0
      // IF length > 0
      // 18Y +

      // Значение тега PatientsAge - это текст в формате -- (n)nnD, (n)nnW, (n)nnM, (n)nnY;
      // где `(n)nn` — это две или три цифры с количеством дней для `D`, недель для `W`, месяцев для `M` или лет для `Y`.
      //  Например, `008M` представляет возраст в 8 месяцев, a 75Y - 75 лет
      // Нам подходят только значения, у которых на конце Y и число nn >= 18. Так что можно проверить сначала последний символ на Y, а затем 2 предпоследних >=18

      console.log("\n\n");
      this.dataSets = this.dataSets.filter((d) => {
        return this.checkDatasetForRules(d);
      });

      if (this.dataSets.length === 0) {
        this.clearUploadState(
          this.$t(this.dicomErrorsTags[0] + "__error").replace(
            "<SERVICE>",
            this.dicomErrorsModalityes.toString()
          ),
          "error"
        );
        return;
      } else {
        filteredFiles = origFiles.filter((file) => {
          return this.$_.findWhere(this.dataSets, { id: file.id });
        });

        this.$debug("Отфильтрованные файлы: ", "warning", filteredFiles);

        this.total_files_filter = filteredFiles.length;

        if (origFiles.length !== filteredFiles.length) {
          setTimeout(() => {
            this.tempCloseAnotherModal = false;
            this.showDicomWarning = true;
          }, 1000);
        }

        setTimeout(() => {
          this.isSomeProcessDone = true;
          this.upload.percent = 100;
          setTimeout(() => {
            this.anonimization(filteredFiles);
          }, 2000);
        });
      }
    },
    checkDicom(dicom, files_length) {
      return new Promise((resolve, reject) => {
        var fr = new FileReader();
        fr.onload = () => {
          this.parsedDicoms += 1;

          this.upload.percent = (this.parsedDicoms * 100) / files_length;

          resolve(
            this.dataSets.push({
              id: dicom.id,
              filename: dicom.file.name,
              extension: dicom.file.type,
              dataset: this.getDataset(new Uint8Array(fr.result)),
            })
          );
        };
        fr.readAsArrayBuffer(dicom.file);
      });
    },
    checkDicomTags(files) {
      this.isSomeProcessDone = false;
      this.upload.text = this.$t("Check");
      this.upload.percent = 0;

      this.$debug("Начинаем чтение меты с дайкомов", "warning", files);
      let promises = [];
      files.map((file) => {
        promises.push(this.checkDicom(file, files.length));
      });
      Promise.all(promises).then(() => {
        this.upload.percent = 99;
        this.$debug(
          "DICOM PARSER: чтение дайком тегов с " +
            files.length +
            " закончено успешно!",
          "success",
          this.dataSets
        );
        this.filterDicoms(files);
      });
    },
    startUpload(e) {
      if (e.target.files.length === 0) {
        this.resetUpload();
        return;
      }

      this.notifying.enabled = false;

      // const files = this.currentWay.checkExtension
      //   ? this.prepareFiles(
      //       Array.from(e.target.files).filter((file) => {
      //         return (
      //           this.moduleObject.accept.indexOf(file.type) !== -1 &&
      //           file.name !== ".DS_Store" &&
      //           file.name !== "DICOMDIR"
      //         );
      //       })
      //     )
      //   : this.prepareFiles(Array.from(e.target.files));

      const files = this.prepareFiles(
        Array.from(e.target.files).filter((file) => {
          return (
            this.moduleObject.accept.indexOf(file.type) !== -1 &&
            file.name !== ".DS_Store" &&
            file.name !== "DICOMDIR"
          );
        })
      );

      if (files.length === 0) {
        this.clearUploadState(this.$t("Error upload"), "error");
        return;
      }

      const reachLimit = this.reachLimit(files);

      if (reachLimit) {
        this.clearUploadState(
          this.$t("Reach files size") + ": " + reachLimit,
          "error"
        );

        return;
      }

      this.selectedServiceForCurrentUpload =
        this.module === "edu" ? this.currentLesson : this.currentService;

      this.$store.dispatch("updateIsUpload", true);

      this.total_files = files.length;

      this.$debug(
        "На аплоуд прокинуто " + files.length + "файлов в " + new Date(),
        "warning"
      );

      if (localStorage.skipDicomTagsCheck === "true" || this.module !== "AI") {
        this.anonimization(files);
      } else {
        this.checkDicomTags(files);
      }
    },
  },
};
</script>
